export default "__VITE_ASSET__BSUp4gOf__"